import { ArrowLeftOutlined } from '@ant-design/icons';
import { RichiestaModuloDTOStatoValidazione } from '@framework/api-client';
import { IBooleanCondition } from '@framework/engine';
import { t } from '@framework/i18n';
import { BrandedPath } from '@framework/ui';
import React from 'react';
import { SubmissionModuleState } from '../../module/fsm/SubmissionModuleState';

export enum SubmissionMenuItemType {
  Cover = 'cover',
  Guide = 'guide',
  Principal = 'principal',
  Module = 'module',
  Section = 'section',
  Payment = 'payment',
  Send = 'send',
}

export interface ISubmissionMenuItem {
  key: string;
  index: string;
  name: string;
  type: SubmissionMenuItemType;
  children?: ISubmissionMenuItem[] | undefined;
  icon?: React.ReactNode;
  to?: BrandedPath;
  context?: {
    /** ID Richiesta modulo, utilizzato come nome per il formHandler del modulo, gestito dal formCoordinator */
    submissionModuleId?: string | null;
    /** ID sezione */
    sectionId?: string | null;
    validationState?: RichiestaModuloDTOStatoValidazione;
    state?: SubmissionModuleState;
  };
  visible?: IBooleanCondition;
  enabled?: IBooleanCondition;
}

/**
 * Primo elementi del menu della Domanda sempre presenti e non modificabili
 *
 * Sempre presente e non modificabile
 */
export const SubmissionBeforeMenuItem: ISubmissionMenuItem[] = [
  {
    key: 'cover',
    index: 'cover',
    name: t('submission-menu-item.scheda-domanda', 'Scheda Domanda'),
    type: SubmissionMenuItemType.Cover,
    icon: <ArrowLeftOutlined aria-hidden="true" />,
  },
];
